import React, { useEffect, useState } from "react";
import backarrow from "../../Assets/svg/backarrow.svg";
import { Container, Row, Col } from "react-bootstrap";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import { apiCall } from "../../services/api-service.js";
import { useNavigate, useLocation } from "react-router-dom";

const ComponentAdd = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const [componentCode, setComponentCode] = useState("");
  const [componentName, setComponentName] = useState("");
  const [estimation, setEstimation] = useState("");
  const [reopenValue, setReopenValue] = useState("");
  const [lastKey, setLastKey] = useState("");
  const [levelOptionList, setLevelOptionList] = useState([
    { value: "", label: "Select" },
  ]);
  const [escalationList, setEscalationList] = useState([
    /* 
            {
                id:0,
                project:[{value:'',label:'Select'}],
                priority:'high', 
                levels:[
                    {
                        id:0,
                        role:{value:'',label:'Select'},
                        designation:{value:'',label:'Select'},
                        user:{value:'',label:'Select'},
                        estimation:''
                    },
                ] 
            } */
  ]);
  const [validations, setValidations] = useState({
    code: "",
    name: "",
    est: "",
    reopen_days: "",
    subcomponents: "",
  });
  useEffect(() => {
    if (id != null && id != undefined) {
      componentEdit(id);
    }
  }, []);

  const handleLevelListDropdownChange = (option, onChangeIndex) => {
    const idx = onChangeIndex?.parentIndex ?? 0;
    const tempList = [...levelOptionList].slice(0, idx);

    if (option && option.value) {
      tempList.push(option);
      tempList.push({ value: "", label: "Select" });
    } else {
      tempList.push({ value: "", label: "Select" });
    }

    setLevelOptionList(tempList);
  };

  const getLevelParams = (index) => {
    if (index === 0) {
      return { project_id: "" };
    } else {
      return {
        parent_id:
          levelOptionList[index - 1] != null
            ? levelOptionList[index - 1].value
            : "",
      };
    }
  };

  const addProjectMappingLevel = () => {
    const tempList = [...escalationList];

    tempList.push({
      id: 0,
      project: [{ value: "", label: "Select" }],
      priority: "high",
      levels: [
        {
          id: 0,
          role: { value: "", label: "Select" },
          designation: { value: "", label: "Select" },
          user: { value: "", label: "Select" },
          estimation: "",
        },
      ],
    });
    setEscalationList(tempList);
  };

  const handleProjectDropdownChange = (selectedOptions, index) => {
    const tempList = [...escalationList];
    const pIndex = tempList[index].project.findIndex(
      (option) => option.value === selectedOptions.value
    );
    if (pIndex > -1) {
      const updatedOptions = tempList[index].project.filter(
        (option) => option.value !== selectedOptions.value
      );
      tempList[index].project = updatedOptions;
      setEscalationList(tempList);
    } else {
      const tempProjectList = [...tempList[index].project];
      tempProjectList.push(selectedOptions);
      tempList[index].project = tempProjectList;
      setEscalationList(tempList);
    }
  };
  const handleRoleDropdownChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...escalationList];
    if (
      tempList[onChangeIndex.parentIndex] !== undefined &&
      tempList[onChangeIndex.parentIndex].levels.length > 0
    ) {
      tempList[onChangeIndex.parentIndex].levels[
        onChangeIndex.childIndex
      ].role = selectedOptions;
      setEscalationList(tempList);
    }
  };
  const handleDesignationDropdownChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...escalationList];
    if (
      tempList[onChangeIndex.parentIndex] !== undefined &&
      tempList[onChangeIndex.parentIndex].levels.length > 0
    ) {
      tempList[onChangeIndex.parentIndex].levels[
        onChangeIndex.childIndex
      ].designation = selectedOptions;
      setEscalationList(tempList);
    }
  };

  const handleUserDropdownChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...escalationList];
    if (
      tempList[onChangeIndex.parentIndex] !== undefined &&
      tempList[onChangeIndex.parentIndex].levels.length > 0
    ) {
      tempList[onChangeIndex.parentIndex].levels[
        onChangeIndex.childIndex
      ].user = selectedOptions;
      setEscalationList(tempList);
    }
  };
  const addMappingLevel = (parentIndex) => {
    const tempList = [...escalationList];
    if (tempList[parentIndex] !== undefined) {
      tempList[parentIndex].levels.push({
        id: 0,
        role: { value: "", label: "Select" },
        designation: { value: "", label: "Select" },
        user: { value: "", label: "Select" },
        estimation: "",
      });
      setEscalationList(tempList);
    }
  };
  const deleteEscalationRow = (parentIndex) => {
    const tempList = [...escalationList];
    if (tempList !== undefined && tempList.length > 0) {
      tempList.splice(parentIndex, 1);
      setEscalationList(tempList);
    }
  };
  const deleteMappingLevel = (parentIndex, childIndex) => {
    const tempList = [...escalationList];
    if (
      tempList[parentIndex] !== undefined &&
      tempList[parentIndex].levels.length > 0
    ) {
      tempList[parentIndex].levels.splice(childIndex, 1);
      setEscalationList(tempList);
    }
  };

  const handleApiError = (errorData) => {
    const validationTemp = { code: "", name: "", est: "", reopen_days: "", subcomponents: "" };
    if (errorData?.error) {
      Object.entries(errorData.error).forEach(([key, value]) => {
        validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
      });
    }
    setValidations(validationTemp);
  };

  const componentSubmit = async () => {
    const tempEscalation = [];
    if (
      !(escalationList.length === 1 &&
        escalationList[0].project.filter((item) => item.value !== "").length === 0)
    ) {
      escalationList.forEach((item) => {
        const transformedLevels = item.levels.map((level) => ({
          id: level.id,
          duration: level.estimation,
          designation_id: level.designation.value,
          role_id: level.role.value,
          user_id: level.user.value,
        }));
        tempEscalation.push({
          id: item.id,
          projects: item.project
            .filter((item) => item.value !== "")
            .map((item) => item.value),
          priority: item.priority,
          lines: transformedLevels,
        });
      });
    }

    setValidations({ code: "", name: "", est: "", reopen_days: "", subcomponents: "" });
    const requestBody = {
      code: componentCode,
      name: componentName,
      est: estimation || null,
      reopen_days: reopenValue ? Number(reopenValue) : null,
      levels: levelOptionList
        .filter((item) => item.value !== "")
        .map((item) => item.value),
      escalations: tempEscalation,
    };

    const isNew = id === null || id === undefined || id === -1;
    const response = await apiCall(
      isNew ? "post" : "put",
      isNew ? "component" : `component/${id}`,
      requestBody
    );
    if (response?.status === 200 && response.data?.success === true) {
      navigate(-1);
    } else if (response?.data?.error) {
      handleApiError(response.data);
    }
  };

  const componentEdit = async (id) => {
    const response = await apiCall("get", `component/${id}`);
    if (response?.status === 200 && response.data?.success === true) {
      const comp = response.data.component;
      setComponentCode(comp.code);
      setComponentName(comp.name);
      setEstimation(comp.component_time);
      setReopenValue(comp.reopen_days);
      setLevelOptionList([...comp.levels, { value: "", label: "Select" }]);
      setEscalationList(
        comp.escalations.map((item) => ({
          id: item.id,
          project: item.projects,
          priority: item.priority,
          levels: item.lines.map((level) => ({
            id: level.id,
            role: { value: level.role_id ?? "", label: level.role },
            designation: { value: level.designation_id ?? "", label: level.designation },
            user: { value: level.user_id ?? "", label: level.user },
            estimation: level.duration,
          })),
        }))
      );
    }
  };
  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // height: "100vh",
            // overflow: "auto",
            // scrollbarWidth: "none",
            // msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div style={{ fontFamily: "Satoshi" }}>
              <div
                className="px-3 py-3 d-flex justify-content-between align-items-center"
                style={{ backgroundColor: "#F3F6F9" }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "12px" }}
                >
                  <div>
                    <img
                      onClick={() => {
                        navigate(-1);
                      }}
                      style={{ cursor: "pointer" }}
                      src={backarrow}
                      alt=""
                    />
                  </div>

                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "16px",
                      color: "#212129",
                    }}
                  >
                    New Component
                  </div>
                </div>

                <div
                  className="d-flex align-items-center"
                  style={{ gap: "12px" }}
                >
                  <button
                    onClick={() => {
                      navigate(-1);
                    }}
                    style={{
                      backgroundColor: "#FFFFFF",
                      color: "#212129",
                      border: "none",
                      borderRadius: "100px",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                    className="px-4 py-2"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={() => {
                      componentSubmit();
                    }}
                    style={{
                      backgroundColor: "#6929E2",
                      color: "#FFFFFF",
                      border: "none",
                      borderRadius: "100px",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                    className="px-4 py-2"
                  >
                    Save
                  </button>
                </div>
              </div>

              <div
                style={{ borderRadius: "16px", backgroundColor: "#FFFFFF" }}
                className="px-3 py-3 mx-3"
              >
                <div className="d-flex flex-column" style={{ gap: "8px" }}>
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "20px",
                      color: "#212129",
                    }}
                  >
                    Add Component
                  </div>

                  <div
                    style={{
                      fontWeight: "400",
                      fontSize: "14px",
                      color: "#8790A1",
                    }}
                  >
                    Enter below details to create new component
                  </div>
                </div>
                <Row>
                  <Col sm={12} md={6} lg={4} xl={3} className="mt-3">
                    <p
                      style={{
                        fontFamily: "Satoshi",
                        fontSize: "13px",
                        fontWeight: "500",
                        lineHeight: "17.55px",
                        color: "#212129",
                        marginBottom: "8px",
                      }}
                    >
                      Component Code<span style={{ color: "red" }}> *</span>
                    </p>

                    <div>
                      <input
                        type="text"
                        value={componentCode}
                        onChange={(event) => {
                          setComponentCode(event.target.value);
                        }}
                        className="px-3 py-2 w-100" // Bootstrap w-100 ensures full width
                        placeholder="Component Code"
                        style={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#212129",
                          border: "0.7px solid #E5E5E5",
                          borderRadius: "10px",
                          backgroundColor: "#FFFFFF",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {validations.code}
                    </span>
                  </Col>
                  <Col sm={12} md={6} lg={4} xl={3} className="mt-3">
                    <p
                      style={{
                        fontFamily: "Satoshi",
                        fontSize: "13px",
                        fontWeight: "500",
                        lineHeight: "17.55px",
                        color: "#212129",
                        marginBottom: "8px",
                      }}
                    >
                      Component Name<span style={{ color: "red" }}> *</span>
                    </p>

                    <div>
                      <input
                        type="text"
                        value={componentName}
                        onChange={(event) => {
                          setComponentName(event.target.value);
                        }}
                        className="px-3 py-2 w-100" // Bootstrap w-100 ensures full width
                        placeholder="Component Name"
                        style={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#212129",
                          border: "0.7px solid #E5E5E5",
                          borderRadius: "10px",
                          backgroundColor: "#FFFFFF",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {validations.name}
                    </span>
                  </Col>
                  <Col sm={12} md={6} lg={4} xl={3} className="mt-3">
                    <p
                      style={{
                        fontFamily: "Satoshi",
                        fontSize: "13px",
                        fontWeight: "500",
                        lineHeight: "17.55px",
                        color: "#212129",
                        marginBottom: "8px",
                      }}
                    >
                      Estimation
                      {/* <span style={{ color: "red" }}> *</span> */}
                    </p>
                    <input
                      className="w-100"
                      id="est"
                      type="text"
                      value={estimation}
                      onChange={(event) => {
                        const inputText = event.target.value;
                        if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                          if (lastKey === "Backspace") {
                            setEstimation(inputText);
                          } else {
                            setEstimation(
                              inputText.length === 2
                                ? inputText + ":"
                                : inputText
                            );
                          }
                        }
                      }}
                      onKeyDown={(event) => {
                        setLastKey(event.key);
                      }}
                      style={{
                        height: "40px",
                        borderRadius: "10px",
                        gap: "77px",
                        padding: "16px",
                        border: "0.7px solid #E5E5E5",
                        fontFamily: "Satoshi",
                        fontWeight: "500px",
                        fontSize: "14px",
                        lineHeight: "18.9px",
                        color: "#21272C",
                        backgroundColor: "#FFFFFF",
                      }}
                      placeholder="hh:mm"
                      maxLength={5}
                    />
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {validations.est}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={6} lg={4} xl={3} className="mt-3">
                    <p
                      style={{
                        fontFamily: "Satoshi",
                        fontSize: "13px",
                        fontWeight: "500",
                        lineHeight: "17.55px",
                        color: "#212129",
                        marginBottom: "8px",
                      }}
                    >
                      Reopen (days)
                    </p>
                    <input
                      className="w-100"
                      id="reopen"
                      type="number"
                      value={reopenValue}
                      onChange={(e) => setReopenValue(e.target.value)}
                      style={{
                        height: "40px",
                        borderRadius: "10px",
                        gap: "77px",
                        padding: "16px",
                        border: "0.7px solid #E5E5E5",
                        fontFamily: "Satoshi",
                        fontWeight: "500px",
                        fontSize: "14px",
                        lineHeight: "18.9px",
                        color: "#21272C",
                        backgroundColor: "#FFFFFF",
                      }}
                      placeholder="Enter here"
                      maxLength={5}
                    />
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {validations.reopen_days ?? ""}
                    </span>
                  </Col>

                  {levelOptionList.map((levelOption, index) => (
                    <Col
                      sm={12}
                      md={6}
                      lg={4}
                      xl={3}
                      key={"level-opt-" + index}
                      className="mt-3"
                    >
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "8px",
                        }}
                      >
                        Level {index + 1}
                      </p>

                      <SearchWithAPI
                        searchId={index}
                        onChangeIndex={{ parentIndex: index }}
                        onDropdownChange={handleLevelListDropdownChange}
                        apiUrl={
                          apiUrl +
                          (index === 0
                            ? "get_parent_component"
                            : "get_child_component")
                        }
                        params={getLevelParams(index)}
                        placeholder={"Select"}
                        selectedValue={
                          levelOption != null ? levelOption.label : ""
                        }
                        selectedOption={levelOption}
                      />
                    </Col>
                  ))}
                </Row>
              </div>

              {/* <div
                style={{ borderRadius: "16px", backgroundColor: "#FFFFFF" }}
                className="px-3 py-3 mx-3 my-3"
              > */}
              {/* <div
                  style={{
                    fontWeight: "700",
                    fontSize: "20px",
                    color: "#212129",
                  }}
                  className="mb-3"
                >
                  Escalations
                </div> */}
              {/* {escalationList.map((escalationLevel, index) => (
                  <div
                    style={{ backgroundColor: "#F5F6F7", borderRadius: "16px" }}
                    className="px-3 py-3 my-3"
                  >
                    <div className="d-flex justify-content-between align-items-between">
                      <Row style={{ width: "100%", gap: "24px" }}>
                        <Col sm={12} md={6} lg={4} xl={3}>
                       
                          <MultiSelectDropDown
                            searchId={index}
                            onDropdownChange={handleProjectDropdownChange}
                            apiUrl={apiUrl + `get_project`}
                            placeholder={"Project"}
                            selectedOption={
                              escalationLevel.project != null
                                ? escalationLevel.project
                                : []
                            }
                          />
                        </Col>
                        <Col sm={12} md={6} lg={4} xl={3}>
                          <div
                            className=""
                            style={{ width: "100%", height: "40px" }}
                          >
                            <select
                              name=""
                              id=""
                              value={escalationLevel.priority}
                              onChange={(event) => {
                                const tempList = [...escalationList];
                                if (tempList[index] !== undefined) {
                                  tempList[index].priority = event.target.value;
                                  setEscalationList(tempList);
                                }
                              }}
                              style={{
                                weight: "400",
                                fontSize: "14px",
                                color: "#8790A1",
                                width: "100%",
                                height: "40px",
                                borderRadius: "10px",
                                border: "0.7px solid #E5E5E5",
                                backgroundColor: "#FFFFFF",
                              }}
                            >
                              <option value="All">All</option>
                              <option value="High">🔴 High Priority</option>
                              <option value="Medium">🟡 Medium Priority</option>
                              <option value="Low">🟢 Low Priority</option>
                            </select>
                          </div>
                        </Col>
                      </Row>

                      <div>
                        <img
                          src={del}
                          onClick={() => {
                            deleteEscalationRow(index);
                          }}
                          style={{ width: "36px", height: "36px" }}
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        borderRadius: "16px",
                        backgroundColor: "#FFFFFF",
                        gap: "16px",
                      }}
                      className="px-3 py-3  my-3"
                    >
                      {escalationLevel.levels.map((mappingLevel, mIndex) => (
                        <Row className="py-1" style={{ width: "100%" }}>
                          <Col sm={12} md={6} lg={4} xl={3} className="mt-2">
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "8px",
                              }}
                            >
                              Role
                            </p>
                            <SearchWithAPI
                              searchId={index}
                              onChangeIndex={{
                                parentIndex: index,
                                childIndex: mIndex,
                              }}
                              onDropdownChange={handleRoleDropdownChange}
                              apiUrl={adminUrl + `get_role`}
                              placeholder={"Role"}
                              selectedValue={
                                mappingLevel.role != null
                                  ? mappingLevel.role.label
                                  : ""
                              }
                              selectedOption={mappingLevel.role}
                            />
                          </Col>

                          <Col sm={12} md={6} lg={4} xl={3} className="mt-2">
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "8px",
                              }}
                            >
                              Designation
                            </p>
                            <SearchWithAPI
                              searchId={index}
                              onChangeIndex={{
                                parentIndex: index,
                                childIndex: mIndex,
                              }}
                              onDropdownChange={handleDesignationDropdownChange}
                              apiUrl={adminUrl + `get_designation`}
                              placeholder={"Designation"}
                              selectedValue={
                                mappingLevel.designation != null
                                  ? mappingLevel.designation.label
                                  : ""
                              }
                              selectedOption={mappingLevel.designation}
                            />
                          </Col>

                          <Col sm={12} md={6} lg={4} xl={3} className="mt-2">
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "8px",
                              }}
                            >
                              User
                            </p>
                            <SearchWithAPI
                              searchId={index}
                              onChangeIndex={{
                                parentIndex: index,
                                childIndex: mIndex,
                              }}
                              onDropdownChange={handleUserDropdownChange}
                              apiUrl={apiUrl + `get_employee`}
                              placeholder={"User"}
                              selectedValue={
                                mappingLevel.user != null
                                  ? mappingLevel.user.label
                                  : ""
                              }
                              selectedOption={mappingLevel.user}
                            />
                          </Col>
                          <Col sm={12} md={4} lg={3} xl={2} className="mt-2">
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "8px",
                              }}
                            >
                              Estimation
                            </p>
                            <input
                              className="w-100"
                              id="est"
                              type="text"
                              value={mappingLevel.estimation}
                              onChange={(event) => {
                                const inputText = event.target.value;
                                if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                                  console.log(event.key);
                                  if (lastKey === "Backspace") {
                                    const tempList = [...escalationList];
                                    if (
                                      tempList[index] !== undefined &&
                                      tempList[index].levels.length > 0
                                    ) {
                                      tempList[index].levels[
                                        mIndex
                                      ].estimation = inputText;
                                      setEscalationList(tempList);
                                    }
                                  } else {
                                    const tempList = [...escalationList];
                                    if (
                                      tempList[index] !== undefined &&
                                      tempList[index].levels.length > 0
                                    ) {
                                      tempList[index].levels[
                                        mIndex
                                      ].estimation =
                                        inputText.length === 2
                                          ? inputText + ":"
                                          : inputText;
                                      setEscalationList(tempList);
                                    }
                                  }
                                }
                              }}
                              onKeyDown={(event) => {
                                setLastKey(event.key);
                              }}
                              style={{
                                height: "44px",
                                borderRadius: "10px",
                                gap: "77px",
                                padding: "16px",
                                border: "0.7px solid #E5E5E5",
                                fontFamily: "Satoshi",
                                fontWeight: "500px",
                                fontSize: "14px",
                                lineHeight: "18.9px",
                                color: "#21272C",
                                backgroundColor: "#FFFFFF",
                              }}
                              placeholder="hh:mm"
                              maxLength={5}
                            />
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {validations.est}
                            </span>
                          </Col>
                          <div
                            style={{
                              width: "70px",
                              display: "flex",
                              alignItems: "end",
                              justifyContent: "center",
                            }}
                            className="mt-2"
                          >
                            <div
                              onClick={() => {
                                deleteMappingLevel(index, mIndex);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "44px",
                                height: "44px",
                                borderRadius: "100px",
                                background: "#F6F7F8",
                              }}
                            >
                              <DeleteRow />{" "}
                            </div>
                          </div>
                        </Row>
                      ))}
                      <div
                        onClick={() => {
                          addMappingLevel(index);
                        }}
                        style={{
                          width: "78px",
                          height: "33px",
                          padding: "8px 16px",
                          borderRadius: "12px",
                          background: "#F4ECFF",
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            fontWeight: "700",
                            color: "#6929E2",
                          }}
                        >
                          + Add
                        </div>
                      </div>
                    </div>
                  </div>
                ))} */}
              {/* <div
                  onClick={() => {
                    addProjectMappingLevel();
                  }}
                  style={{
                    width: "153px",
                    height: "33px",
                    padding: "8px 16px",
                    borderRadius: "12px",
                    background: "#F4ECFF",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "Satoshi",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      fontWeight: "700",
                      color: "#6929E2",
                    }}
                  >
                    + Add Escalation
                  </div>
                </div>  */}
              {/* </div>  */}
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default ComponentAdd;
